import * as ambassadorWixEcomV1BackInStockSettings from './ecom-v1-back-in-stock-settings-back-in-stock-settings.http.js';
import * as ambassadorWixEcomV1BackInStockSettingsTypes from './ecom-v1-back-in-stock-settings-back-in-stock-settings.types.js';
import * as ambassadorWixEcomV1BackInStockSettingsUniversalTypes from './ecom-v1-back-in-stock-settings-back-in-stock-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function startCollectingRequests(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1BackInStockSettingsUniversalTypes.StartCollectingRequestsRequest,
  ambassadorWixEcomV1BackInStockSettingsTypes.StartCollectingRequestsRequest,
  ambassadorWixEcomV1BackInStockSettingsUniversalTypes.StartCollectingRequestsResponse,
  ambassadorWixEcomV1BackInStockSettingsTypes.StartCollectingRequestsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockSettings.startCollectingRequests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/back-in-stock-notification-requests/settings/start-collecting',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function stopCollectingRequests(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1BackInStockSettingsUniversalTypes.StopCollectingRequestsRequest,
  ambassadorWixEcomV1BackInStockSettingsTypes.StopCollectingRequestsRequest,
  ambassadorWixEcomV1BackInStockSettingsUniversalTypes.StopCollectingRequestsResponse,
  ambassadorWixEcomV1BackInStockSettingsTypes.StopCollectingRequestsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockSettings.stopCollectingRequests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/back-in-stock-notification-requests/settings/stop-collecting',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSettings(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixEcomV1BackInStockSettingsUniversalTypes.GetSettingsRequest,
  ambassadorWixEcomV1BackInStockSettingsTypes.GetSettingsRequest,
  ambassadorWixEcomV1BackInStockSettingsUniversalTypes.GetSettingsResponse,
  ambassadorWixEcomV1BackInStockSettingsTypes.GetSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockSettings.getSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/back-in-stock-notification-requests/settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  BackInStockSettings as BackInStockSettingsOriginal,
  BackInStockCollectionState as BackInStockCollectionStateOriginal,
  StartCollectingRequestsRequest as StartCollectingRequestsRequestOriginal,
  StartCollectingRequestsResponse as StartCollectingRequestsResponseOriginal,
  StopCollectingRequestsRequest as StopCollectingRequestsRequestOriginal,
  StopCollectingRequestsResponse as StopCollectingRequestsResponseOriginal,
  GetSettingsRequest as GetSettingsRequestOriginal,
  GetSettingsResponse as GetSettingsResponseOriginal,
  StartCollectingRequestsApplicationErrors as StartCollectingRequestsApplicationErrorsOriginal,
} from './ecom-v1-back-in-stock-settings-back-in-stock-settings.types.js';
